import { makeStyles } from "@material-ui/styles"
import { CELL_PADDING, CELL_WIDTHS } from "@utils";

const useStyle = makeStyles(() => ({
  visibilityCell: {
    width: CELL_WIDTHS.VISIBILITY,
    minWidth: CELL_WIDTHS.VISIBILITY,
    padding: CELL_PADDING,
    position: "absolute",
    right: -CELL_WIDTHS.VISIBILITY,
    zIndex: 10,
  },
}));

export default useStyle;
